import { render, staticRenderFns } from "./ConnectYourDomainModal.vue?vue&type=template&id=f8868892&scoped=true&"
import script from "./ConnectYourDomainModal.vue?vue&type=script&lang=js&"
export * from "./ConnectYourDomainModal.vue?vue&type=script&lang=js&"
import style0 from "./ConnectYourDomainModal.vue?vue&type=style&index=0&id=f8868892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8868892",
  null
  
)

export default component.exports